exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".release-note-tr{\n    border: 1px dashed grey;\n}\n.release-note-point{\n    font-size:small;\n    line-height: 1.2em !important;\n    \n}", ""]);

